'use strict';

import React, { Fragment } from 'react'

import Layout from '@Layout/BackOffice'

import { handleChange } from '@/Form/Functions/eventsHandling'

import getFormStatus from '@/Form/Functions/getFormStatus'

import FormElement from '@/Form/toolkit/FormElement'

import ajaxRequest from '@function/ajax/ajaxRequest'
import bemit       from '@function/bemit'

import Loader from '@Pure/Loader'

const { app } = window;

export default class ResetOrderPage extends React.Component
{
	state = { form_data: { }, status_messages: { } };

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleChange = handleChange.bind(this);

	submit = async () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		try
		{
			var response = await ajaxRequest('/order/reset',
			{
				data: state.form_data,
				axios_params: { timeout: 40 * 1000 }
			});
		}
		catch (e)
		{
			console.error(e);

			return component.setState({ ...e });
		}

		return component.setState(
		{
			...response,
			form_data: { ...state.form_data, number: '' },
			loading: false,
			error: undefined
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true
		? <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		: undefined;

		const form =
		(
			<Fragment>
				<FormElement name="number"
					type="text" data={ state.form_data }
					onChange={ component.handleChange }
					status={ state.status_messages }
					label="Numéro de la commande"
				/>

				<FormElement name="keep_uploaded"
					type="checkbox" data={ state.form_data }
					onChange={ component.handleChange }
					status={ state.status_messages }
					label="Conserver les fichiers déjà ajoutés ou codes promos attribués"
				/>

				<button type="button"
					className={ bemit('c-btn', ['extra']) }
					onClick={ component.submit }>
					Valider et réinitialiser
					{ loader }
				</button>
			</Fragment>
		);

		const output =
		(
			<Layout history={ props.history }
				page_title="Réinitialiser une commande">

				<div className="page-content">

					<div className="o-content">
						{ form }

						{ getFormStatus(state) }
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
